<template>
  <div>
    <p class="section-title" v-if="shopObj">Account</p>
    <router-view v-if="routeReady" />
    <Loading v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import routeReady from '@/mixins/routeReady'

export default {
  mixins: [ routeReady ],
  computed: mapState([ 'shopObj' ])
}
</script>
